import React from 'react';
import Provider from './Provider';
import Doc from './Doc';

const Wrapper = ({children}) => {

    return <Provider>
        {children}
        <Doc />
    </Provider>
}

export default Wrapper;
